import { Injectable } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, retry, throwError, timer } from 'rxjs';

/** A request that must never be sent twice: a question to the assistant would be asked twice. */
export const NO_RETRY = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {

  constructor(
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        // One quick retry, not a campaign. This runs on a landing site where hydration — and
        // with it event replay, i.e. whether clicks work at all — waits for the app to become
        // stable. The old 30 × 2s meant an unreachable API froze every click for a minute
        // (NG0506); even a couple of 2s delays overshot hydration's 10s budget, because a
        // refused connection itself takes ~2s to fail. One 500ms retry keeps the worst-case
        // storm under ~5s, and anything still down after two attempts stays down.
        count: 1,
        delay: (error) => {
          if (error.status === 0 && !request.context.get(NO_RETRY)) {
            return timer(500); // network-level failure — worth one more try, quickly
          }
          return throwError(() => error); // real HTTP status — do not retry
        },
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status != 200) {
          console.log(`API Error (${error.status}): ${error.error?.message}`)
        } else {
          console.error(`API Error (${error.status}):`)
          console.error(error)
        }
        throw error;
      })
    );
  }
}
